exports['aes-256-gcm'] = require('./aes-gcm-cipher');
